var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProducer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 26.1666H21C21.6189 26.1666 22.2124 25.9208 22.6499 25.4832C23.0875 25.0456 23.3334 24.4522 23.3334 23.8333V8.66665L17.5 2.83331H7.00002C6.38118 2.83331 5.78769 3.07915 5.3501 3.51673C4.91252 3.95432 4.66669 4.54781 4.66669 5.16665V9.83331",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 2.83331V7.49998C16.3333 8.11882 16.5791 8.71231 17.0167 9.1499C17.4543 9.58748 18.0478 9.83331 18.6666 9.83331H23.3333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5H3.49998C2.85565 14.5 2.33331 15.0223 2.33331 15.6667V20.3333C2.33331 20.9777 2.85565 21.5 3.49998 21.5H10.5C11.1443 21.5 11.6666 20.9777 11.6666 20.3333V15.6667C11.6666 15.0223 11.1443 14.5 10.5 14.5Z",
    fill: "#FF8B63",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.5833L16.3334 21.5V14.5L11.6667 17.4167",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProducer);
export default __webpack_public_path__ + "static/media/Icon-Producer.dc2a8fae6f5580c68bad841f97b30051.svg";
export { ForwardRef as ReactComponent };